import React from 'react';
import { FiLinkedin } from 'react-icons/fi';
import siteData from '../data/siteData';
import ScrollReveal from '../components/ScrollReveal';

const EXTENDED_MEMBERS = [
  ...siteData.homepage_sections.our_team.members,
];

const COLORS = [
  ['#198754', '#0d6efd'],
  ['#146c43', '#0b5ed7'],
  ['#20c997', '#0dcaf0'],
  ['#0d6efd', '#20c997'],
  ['#198754', '#20c997'],
  ['#0f5132', '#0d6efd'],
  ['#0b5ed7', '#0dcaf0'],
  ['#146c43', '#20c997'],
];

export default function TeamPage() {
  const { description, firm_registration, date_of_incorporation } = siteData.homepage_sections.our_team;

  return (
    <div className="page-wrapper">
      {/* Page hero */}
      <div className="page-hero">
        <h1>Our <span>Expert Team</span></h1>
        <p>Competent professionals dedicated to delivering excellence</p>
      </div>

      <main className="team-page-main">
        <div className="container">
          {/* Intro */}
          <div className="team-page-intro">
            <p className="team-page-intro-text">{description}</p>
            
            {(firm_registration || date_of_incorporation) && (
              <div className="team-page-meta-box">
                {firm_registration && <span className="team-page-meta-item">{firm_registration}</span>}
                {firm_registration && date_of_incorporation && <span className="team-page-meta-sep">|</span>}
                {date_of_incorporation && <span className="team-page-meta-item">{date_of_incorporation}</span>}
              </div>
            )}
          </div>

          {/* Grid */}
          <div className="team-page-grid">
            {EXTENDED_MEMBERS.map((member, i) => {
              const [c1, c2] = COLORS[i % COLORS.length];
              return (
                <ScrollReveal key={member.name} delay={i * 100} className="team-page-card-wrapper">
                  <div className="team-page-card">
                    <div className="team-page-card-top" style={{ background: `linear-gradient(135deg, ${c1}, ${c2})` }}>
                      <div className="team-page-avatar">
                        {member.photo ? (
                          <img src={member.photo} alt={member.name} className="team-page-avatar-img" />
                        ) : (
                          <span>{member.initials}</span>
                        )}
                      </div>
                    </div>
                    <div className="team-page-card-body">
                      <h3 className="team-page-name">{member.name}</h3>
                      <span className="team-page-designation">{member.designation}</span>
                      <div className="team-page-divider" />
                      <p className="team-page-bio">{member.description}</p>
                      <div className="team-page-actions">

                        <a href="https://www.linkedin.com/company/asrm-co/" target="_blank" rel="noopener noreferrer" className="team-page-action">
                          <FiLinkedin size={14} /> LinkedIn
                        </a>
                      </div>
                    </div>
                  </div>
                </ScrollReveal>
              );
            })}
          </div>


        </div>
      </main>
    </div>
  );
}
